export default {
  instance: null,
  session: null,
  subscribers: [],
  list: []
}
